import { userStore } from '../stores/user.store';

export const useUserStore = () => userStore;
